// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure_figure__dimvk","caption":"Figure_caption__AZCvO"};